import React from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

/**
 * Barra de Deshacer del borrado de notificaciones.
 *
 * Vive fuera del panel, en un portal sobre el body, porque el borrado más común
 * es tocar una notificación: eso cierra la campanita y navega al hallazgo, y una
 * barra dibujada adentro del panel se desmontaba junto con él. La vuelta atrás
 * tiene que sobrevivir al camino que la necesita.
 *
 * Abajo y centrada: los avisos efímeros ocupan arriba a la derecha, el panel se
 * despliega debajo de la campanita, y la esquina inferior izquierda ya la tiene
 * el selector de vista, que la tapaba entera.
 */
const NotificationUndoBar = ({ count, onUndo }) => {
	const { t } = useTranslation()

	if (typeof document === 'undefined' || !count) {
		return null
	}

	return createPortal(
		<div
			role="status"
			className="fixed bottom-4 left-1/2 -translate-x-1/2 w-[calc(100%-2rem)] max-w-sm z-[9999]
				flex items-center justify-between gap-2 px-3.5 py-2.5 rounded-lg shadow-lg
				bg-gray-800 dark:bg-gray-600 text-white text-xs"
		>
			<span>
				{count === 1
					? t('notification_deleted', 'Notificación borrada')
					: t('notifications_deleted', `${count} notificaciones borradas`)}
			</span>
			<button
				type="button"
				onClick={onUndo}
				className="font-bold text-indigo-300 hover:bg-white/10 px-2.5 py-1 rounded shrink-0"
			>
				{t('undo', 'Deshacer')}
			</button>
		</div>,
		document.body
	)
}

export default NotificationUndoBar
